import React from 'react';

import { Ellipsis } from 'react-awesome-spinners';

const Spinner = () => {
  return <Ellipsis />;
};

export default Spinner;
